import { Colors, Metrics, Typography } from "../../resources";
import { StyleSheet, Text, View } from "react-native";

import { Bar } from "react-chartjs-2";
import React from "react";
import { Space } from "../../types";
import moment from "moment";

const DAYS_IN_WEEK = 7;

interface IProps {
  space: Space;
  report: any;
  height: number;
  disabled?: boolean;
}

const SLineChart: React.FC<IProps> = ({
  space,
  report,
  height,
  disabled = false,
}) => {
  // const width =
  //   Metrics.screenWidth -
  //   2 * Metrics.paddingLarge -
  //   4 * Metrics.paddingSmall -
  //   Metrics.iconSmall -
  //   Metrics.paddingSmallStandard -
  //   2 * Metrics.sizeStandard -
  //   Metrics.sizeGigaLarge;

  // Bar chart Day over Day
  let numDaysInChart = 227;
  let chartData;
  let dateRangesStrFormat;
  if (report.length >= numDaysInChart) {
    chartData = report
      .slice(report.length - numDaysInChart)
      .map((item: { interval: { analytics: { max: any } } }) => {
        return item.interval.analytics.max;
      });
    let immutableDateRange = new Set();
    report
      .slice(report.length - numDaysInChart)
      .map((item: { timestamp: any }) => {
        immutableDateRange.add(item.timestamp);
      });
    dateRangesStrFormat = Array.from(immutableDateRange);
    // dateRangesStrFormat = report
    //   .slice(report.length - numDaysInChart)
    //   .map((item: { timestamp: any }) => {
    //     return item.timestamp;
    //   });
  } else {
    chartData = report.map((item: { max: any }) => {
      return item.max;
    });
    dateRangesStrFormat = report.map((item: { timestamp: any }) => {
      return item.timestamp;
    });
  }

  // Add this week days to fill the week
  const lastDate = moment(dateRangesStrFormat[dateRangesStrFormat.length - 1]);
  const lastWeekday = lastDate.isoWeekday();
  for (let day = 1; day <= DAYS_IN_WEEK - lastWeekday; day++) {
    dateRangesStrFormat.push(
      lastDate.add(1, "days").format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
    chartData.push(0);
  }

  // HACK: API v1 need to adjust the data array length
  chartData = chartData.slice(
    chartData.length - dateRangesStrFormat.length,
    chartData.length
  );

  // Determine the max chart value
  let maxChartValue = space.safe_capacity * 1.4;

  const dataColor = (data: any) => {
    let peakOccupancy = data.dataset.data[data.dataIndex];
    let safePercentage = Math.round(
      (space.safe_capacity / space.target_capacity) * 100
    );
    let percentAvgSafetyPercentage =
      (peakOccupancy * 100) / space.safe_capacity;
    if (percentAvgSafetyPercentage < 80) {
      return Colors.green40040percent;
    } else if (percentAvgSafetyPercentage < 100) {
      return Colors.yellow40040percent;
    } else {
      return Colors.red40040percent;
    }
  };

  const data = {
    labels: dateRangesStrFormat,
    datasets: [
      {
        backgroundColor: dataColor,
        data: chartData,
        barThickness: 2,
        maxBarThickness: 2,
      },
    ],
  };

  return (
    <View
      style={[
        styles.container,
        {
          width: "100%",
          justifyContent: "center",
          alignItems: disabled ? "center" : "flex-end",
          overflow: "hidden",
        },
      ]}
    >
      {disabled ? (
        <View
          style={{
            alignItems: "center",
          }}
        >
          <Text style={styles.title}>Add capacity</Text>
        </View>
      ) : (
        <View
          style={{
            width: 1400,
            height: Metrics.size96 - 10,
          }}
        >
          <Bar
            data={data}
            height={Metrics.size96 - 10}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              legend: { display: false },
              elements: {},
              scales: {
                yAxes: [
                  {
                    ticks: {
                      fontSize: 10,
                      beginAtZero: true,
                      max: maxChartValue,
                      callback: (value: number, index: any, values: any) => {
                        return value === 0 ? "" : " ";
                      },
                    },
                    afterBuildTicks: (_axis: any, ticks: any) => {
                      return [0, space.safe_capacity];
                    },
                  },
                ],
                xAxes: [
                  {
                    ticks: {
                      fontSize: 10,
                      maxRotation: 0,
                      minRotation: 0,
                      callback: (item: any, index: any) => {
                        if (moment(item).toString() !== "") {
                          return item;
                        }
                      },
                      autoSkip: false,
                    },
                    afterBuildTicks: (scale: any, ticks: any) => {
                      let newTicks = ticks.map((tick: any) => {
                        if (moment(tick).day() === 1) {
                          return moment(tick).format("MMM DD");
                        }
                      });
                      return newTicks;
                    },
                  },
                ],
              },
              tooltips: {
                callbacks: {
                  title: (tooltipItems: any, data: any) => {
                    console.log(tooltipItems);
                    return moment(tooltipItems[0].xLabel).format("ddd, MMM Do");
                  },
                },
              },
            }}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: Metrics.size96 - 10,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.grey200,
    marginVertical: 5,
    marginRight: 5,
  },
  title: {
    ...Typography.headline0,
    color: Colors.grey300,
  },
});

export default SLineChart;
